import { Box, Container, Typography, Button, Link } from "@mui/material";
import WhatsApp from "@mui/icons-material/WhatsApp";
import React from "react";
import { useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Banner from "../components/landing/Banner";
import Faqs from "../components/landing/Faqs";
import Services from "../components/landing/Services";
import About from "../components/landing/About";
import Nav from "../components/landing/Nav";
import Footer from "../components/landing/Footer";
import Launch from "../components/landing/Launch";
// media mentions
import med1 from "../images/1.png";
import med2 from "../images/2.png";
import med3 from "../images/3.png";
import med4 from "../images/4.png";
import med5 from "../images/5.png";
import med6 from "../images/6.png";
import med7 from "../images/7.png";
import med8 from "../images/8.png";


const mentions = [med1, med2, med3, med4, med5, med6, med7, med8]

export default function LandingPage() {
  const navigate = useNavigate();
  return (
    <>
    <Nav/>
      <Banner />
      <About />
      <Services />
      <Launch />
      {/* Frequently asked questions */}
      <Box sx={{ width: "100%", pt: 5, textAlign: "center" }}>
        <Container maxWidth="lg">
          <Typography variant="h3">Frequently asked questions</Typography>
          <Typography variant="subtitle1">
            Can’t find what you are looking for? Drop an email to
            connect@keywordfly.com
          </Typography>
          <Faqs />
        </Container>
      </Box>
      <Box sx={{ width: "100%", pt: 5, textAlign: "center" }}>
        <Container maxWidth="lg">
          <Typography variant="h3">Our Media Mentions</Typography>
          <Marquee>
            {mentions.map((e, i) =>
              <img
                key={i}
                src={e}
                style={{ marginRight: 24 }}
                height={124}
                alt="mention"
              />
            )}
          </Marquee>
        </Container>
      </Box>
      <Box
        sx={{
          width: "100%",
          padding: "20px 0px",
          textAlign: "center",
          color: "black",
          mt: 4
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h3" sx={{ color: "inherit" }}>
          Start Building Your Business With Us!
          </Typography>
          <Typography sx={{ color: "inherit" }}>
          Use in-built marketing and sales tools to grow your 
          audience and increase revenue from day one. “KeywordsFly" 
          is the right decision for your Business! Our team will be creative,
           and experts to help you from A to Z solutions.
          </Typography>
          <br/>
          <Button size="large" variant="contained">
            Register Here
          </Button>
        </Container>
      </Box>
      <div
        style={{
          position: "fixed",
          bottom: 16,
          right: 16,
          backgroundColor: "#25D366",
          borderRadius: "50%",
          padding: 6,
          zIndex: 99
        }}
      >
        <Link
          href="https://wa.me/+918527675415"
          sx={{
            display: "flex",
            alignItems: "center"
          }}
        >
          <WhatsApp fontSize="large" sx={{ color: "white" }} />
        </Link>
      </div>
      <Footer />
    </>
  );
}
